import {
	LOAD_GROUP_DEALS,
	LOAD_GROUP_DEAL,
	CREATE_GROUP_DEAL,
	UPDATE_GROUP_DEAL,
	REMOVE_GROUP_DEAL,
	GROUP_DEALS_LOADING,
	GROUP_DEALS_ERROR,
} from '../actionTypes';

const initialState = {
	list: [],
	currentDeal: null,
	loading: false,
	error: null,
	lastFetched: null,
};

export const groupDeals = (state = initialState, action) => {
	switch (action.type) {
		case GROUP_DEALS_LOADING:
			return {
				...state,
				loading: true,
				error: null,
			};

		case GROUP_DEALS_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case LOAD_GROUP_DEALS:
			return {
				...state,
				list: Array.isArray(action.deals) ? action.deals : [],
				loading: false,
				error: null,
				lastFetched: Date.now(),
			};

		case LOAD_GROUP_DEAL:
			return {
				...state,
				currentDeal: action.deal || null,
				loading: false,
				error: null,
				lastFetched: Date.now(),
			};

		case CREATE_GROUP_DEAL:
			return {
				...state,
				list: [action.deal, ...state.list],
				currentDeal: action.deal,
				loading: false,
				error: null,
				lastFetched: Date.now(),
			};

		case UPDATE_GROUP_DEAL:
			return {
				...state,
				list: state.list.map((deal) =>
					deal._id === action.deal._id ? action.deal : deal,
				),
				currentDeal:
					state.currentDeal && state.currentDeal._id === action.deal._id
						? action.deal
						: state.currentDeal,
				loading: false,
				error: null,
				lastFetched: Date.now(),
			};

		case REMOVE_GROUP_DEAL:
			return {
				...state,
				list: state.list.filter((deal) => deal._id !== action.dealId),
				currentDeal:
					state.currentDeal && state.currentDeal._id === action.dealId
						? null
						: state.currentDeal,
				loading: false,
				error: null,
			};

		default:
			return state;
	}
};
